var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sale.price_description)?_c('b-button',{staticClass:"m-l-5",attrs:{"variant":"outline-info","size":"sm"},on:{"click":function($event){$event.stopPropagation();return _vm.show.apply(null, arguments)}}},[_vm._v(" ? ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }